import $store from '@/store/index'
import BotApi from '@/util/botapi'
import Apis from '@/util/apis'
import Gridapis from '@/util/gridapis'
import Data from '@/util/data'
import util from '@/util/util'
import { log } from '@chenfengyuan/vue-qrcode'

export default {
  UpdateGridsBalance () {
    if (!$store.state.sys.tradeExchange.Id) {
      return
    }
    return Apis[util.exchId2sputnik()]
      .get('asset/balance?token=' + $store.state.sys.token + '&etid=' + $store.state.sys.tradeExchange.Id + '&symbol=' +
        $store.state.grids.symbol
      )
      .then(response => {
        $store.state.grids.lastPrice = response.data.LastPrice
        $store.state.grids.freeBal = response.data.QAssetFree
        // console.log('UpdateGridsBalance', $store.state.grids.lastPrice, $store.state.grids.freeBal)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  SelectGridsSymbol (symbol) {
    // if (!$store.state.grids.exchSymbol) {
    //   $store.state.grids.exchSymbol = {}
    // }
    // $store.state.grids.exchSymbol[$store.state.sys.tradeExchange.Id] = symbol
    // // localStorage.setItem('capico_app_gridExchSymbol', JSON.stringify($store.state.grids.exchSymbol))
    // $store.state.grids.symbol = symbol

    symbol = symbol.replace('/', '_')
    if (!$store.state.grids.exchSymbol) {
      $store.state.grids.exchSymbol = {}
    }
    $store.state.grids.exchSymbol[$store.state.sys.tradeExchange.Id] = symbol
    $store.state.grids.symbol = symbol
    localStorage.setItem('capico_app_botSymbol', symbol)
    localStorage.setItem('capico_app_botExchSymbol', JSON.stringify($store.state.grids.exchSymbol))
  },
  SaveGrid () {
    const grid = $store.state.grids
    // $store.state.sys.token
    const filt = $store.state.data.symbolsfilter[grid.symbol]
    // if (!filt) {
    //   return
    // }
    const params = {
      etid: $store.state.sys.tradeExchange.Id,
      symbol: grid.symbol,
      invested: grid.amount,
      grids: parseInt(grid.gridsNum),
      min_price: grid.minPrice,
      max_price: grid.maxPrice,
      qty_dec: filt.QtyDec,
      lot_size: filt.QtyMin,
      price_dec: filt.PriceDec,
      dry: 0
    }

    if (grid.profitCollection !== 'USDT') {
      params.profincoin = '1'
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].post('new', params, {
      headers
    })
  },
  CancelGrid (gid, sell) {
    const params = {
      gid
    }
    if (sell) {
      params.sell = '1'
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('cancel', { params, headers })
  },
  GetGridSellsBySymbol () {
    const params = {
      etid: $store.state.sys.tradeExchange.Id,
      symbol: $store.state.grids.symbol
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('sells', { params, headers })
  },
  GetGridExecs (gid, hist) {
    const params = {
      gid,
      b: '',
      h: hist
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('execs', { params, headers })
  },
  GetGridOpenOrdersBySymbol () {
    const params = {
      etid: $store.state.sys.tradeExchange.Id,
      symbol: $store.state.grids.symbol
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('symbol_orders', { params, headers })
  },
  GetGridsByEtid (etid, hist) {
    const params = {
      etid,
      h: hist
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('list', { params, headers })
  },
  FixBuys (gid) {
    const params = {
      gid
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('fixbuys', { params, headers })
  },
  GetMRate (etid) {
    const params = {
      etid
    }
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('mrate', { params, headers })
  },
  Backsim (params) {
    const headers = {
      'CTKN': $store.state.sys.token
    }
    return Gridapis[util.exchId2sputnik()].get('backsim', { params, headers })
  }
}
